/**
 * Dado um hex (#RRGGBB), converte para objeto { r, g, b }
 */
function hexToRgb(hex) {
  const clean = hex.replace('#', '');
  return {
    r: parseInt(clean.substring(0, 2), 16),
    g: parseInt(clean.substring(2, 4), 16),
    b: parseInt(clean.substring(4, 6), 16),
  };
}

/**
 * Clareia ou escurece um hex.
 * amount: positivo = clareia, negativo = escurece (escala 0–255)
 */
function adjustBrightness(hex, amount) {
  const { r, g, b } = hexToRgb(hex);
  const clamp = (v) => Math.min(255, Math.max(0, v));
  const toHex = (v) => clamp(v + amount).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/**
 * Decide se o texto sobre a cor deve ser branco ou preto
 * baseado na luminância relativa (WCAG).
 */
function getContrastColor(hex) {
  const { r, g, b } = hexToRgb(hex);
  // fórmula de luminância relativa
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#1A1A2E' : '#FFFFFF';
}

/**
 * Recebe as cores brutas da academia (do Firestore)
 * e retorna um mapa completo de variáveis CSS a injetar.
 *
 * @param {string} primary   - cor primária hex da academia
 * @param {string} [accent]  - cor de destaque hex (opcional, usa primary se omitido)
 * @returns {Record<string, string>}
 */
export function buildGymCssVars(primary, accent) {
  const resolvedAccent = accent || primary;

  return {
    '--gym-primary':            primary,
    '--gym-primary-hover':      adjustBrightness(primary, -20),
    '--gym-primary-dark':       adjustBrightness(primary, +50),   // versão mais clara para dark mode
    '--gym-primary-dark-hover': adjustBrightness(primary, +70),
    '--gym-accent':             resolvedAccent,
    '--gym-accent-hover':       adjustBrightness(resolvedAccent, -20),
    '--gym-text-on-primary':    getContrastColor(primary),
  };
}

/**
 * Injeta as CSS vars no elemento <html> (ou qualquer elemento).
 */
export function injectCssVars(vars, element = document.documentElement) {
  Object.entries(vars).forEach(([key, value]) => {
    element.style.setProperty(key, value);
  });
}

/**
 * Remove as CSS vars da academia do <html>.
 * Chamado quando o usuário desvincula da academia.
 */
export function clearGymCssVars(element = document.documentElement) {
  const gymVarNames = [
    '--gym-primary', '--gym-primary-hover',
    '--gym-primary-dark', '--gym-primary-dark-hover',
    '--gym-accent', '--gym-accent-hover',
    '--gym-text-on-primary',
  ];
  gymVarNames.forEach((key) => element.style.removeProperty(key));
}